import './AboutSection.scss'
import {Link} from 'react-router-dom'
import config from '../../../../config'
import content from './content.json'
import {HowItWorks} from './components/HowItWorks'
import React from 'react'
import Deco from './components/Deco'

export const AboutSection = () => {
    return (
        <>
            <section id={'about'} className={'about-section'}>
                <h2 className={'about-section-header'}>{content?.title1}<br/>{content?.title2}</h2>
                <p className={'about-section-description'}>{content?.description}</p>
                <div className={'about-container'}>
                    <div>
                        <h3 className={'about-header'}>
                            <span aria-hidden="true" className="material-symbols-outlined">check</span>
                            {content?.pillars[0]?.title}
                        </h3>
                        <p className={'about-text'}>
                            {content?.pillars[0]?.text}
                            <Link to={config.root + '/docs'}>{content?.pillars[0]?.linkTitle}</Link>.
                        </p>
                    </div>
                    <div>
                        <h3 className={'about-header'}>
                            <span aria-hidden="true" className="material-symbols-outlined">check</span>
                            {content?.pillars[1]?.title}
                        </h3>
                        <p className={'about-text'}>{content?.pillars[1]?.text}</p>
                    </div>

                    <div>
                        <h3 className={'about-header'}>
                            <span aria-hidden="true" className="material-symbols-outlined">check</span>
                            {content?.pillars[2]?.title}
                        </h3>
                        <p className={'about-text'}>{content?.pillars[2]?.text}</p>
                    </div>
                </div>
                <Deco />
            </section>
            <HowItWorks />
        </>
    )
}